import { Input, HostListener, OnInit, OnChanges, SimpleChanges, Output, Component, ElementRef, EventEmitter, AfterViewInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { trigger, style, transition, animate, keyframes, query, stagger, group, state, animateChild } from '@angular/animations';

@Component({
  selector: 'color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  animations: [
    trigger(
      'disolveAnimation', [
        transition(':enter', [
          style({'opacity': '0'}),
          animate('200ms', style({'opacity': '1'}))
        ]),
        transition(':leave', [
          style({'opacity': '1'}),
          animate('200ms', style({'opacity': '0'}))
        ])
      ]
    )
  ]
})
export class ColorPickerComponent implements OnInit {

  // Input Variables
  @Input() colors: any[];
  @Input() selected: string;
  @Input() show: boolean;
  @Input() title: string;
  @Input() align: string;

  @Output() onColorPickerChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public colorPickerChange(color) {
    this.onColorPickerChange.emit(color);
  }

  private validateColor(color) {
    return /^#[0-9A-F]{3,6}$/i.test(color);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/color-picker/color-picker.component.ts